import { updateQueryStringParameter, getHashQuery } from '@/utils/index';

export function isDark() {
  const ua = window.navigator.userAgent;
  const regex = /hxtheme\/(\d)/;
  const result = ua.match(regex)?.[1];

  return !!result && result === '1';
}

export const IsDark = isDark;

export function genLinkNewWebview(url) {
  const { href, hash } = window.location;
  const ckey = getHashQuery('ckey') || window.ckey || getHashQuery('accessKey');
  const targetUrl = ckey ? updateQueryStringParameter(url, 'ckey', ckey) : url;
  const webviewUrl =
    `${href.replace(hash, '')}#${targetUrl}`;
  const newUrl = `client.html?action=ymtz^url=${webviewUrl}^webid=2804`;

  return newUrl;
}
export function jumpActivity(_type, url) {
  if (!url) {
    return;
  }
  window.location.href = genLinkNewWebview(url);
}
